"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductAttributesFullSchema = exports.ProductAttributesSchema = void 0;
const zod_1 = require("zod");
const image_1 = require("./image");
const product_item_full_1 = require("./product_item_full");
const product_type_1 = require("./product_type");
const product_variant_group_1 = require("./product_variant_group");
exports.ProductAttributesSchema = zod_1.z.object({
    id: zod_1.z.number(),
    name: zod_1.z.string(),
    brand: zod_1.z.string(),
    description: zod_1.z.string(),
    slug: zod_1.z.string().optional(),
    imageOrdering: zod_1.z
        .array(zod_1.z.number().int().positive())
        .nullable()
        .optional()
        .default([])
        .transform((val) => Array.from(new Set(val))),
});
exports.ProductAttributesFullSchema = exports.ProductAttributesSchema.merge(zod_1.z.object({
    Images: zod_1.z.array(image_1.ImageAttributesSchema).nullable().optional(),
    ProductVariantGroups: zod_1.z
        .array(product_variant_group_1.ProductVariantGroupAttributesSchema)
        .nullable()
        .optional(),
    ProductTypes: zod_1.z.array(product_type_1.ProductTypeAttributesSchema).nullable().optional(),
    ProductItems: zod_1.z
        .array(product_item_full_1.ProductItemAttributesFullSchema)
        .nullable()
        .optional(),
    assetCount: zod_1.z.number().nullable().optional()
}));
//# sourceMappingURL=product.js.map